var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorimg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 76,
    viewBox: "0 0 350 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.507 0.233154C294.837 0.233154 279.52 14.7788 277.351 33.4706C226.634 37.5828 77.933 37.9227 19.2614 34.0484C17.7823 30.276 14.1995 27.5912 10.0251 27.5912C4.50309 27.5912 0 32.2471 0 37.9567C0 43.6662 4.50309 48.3222 10.0251 48.3222C14.1995 48.3222 17.7494 45.6713 19.2614 41.933C85.7888 37.9907 219.172 38.2626 277.351 42.3748C279.454 61.1346 294.804 75.7142 313.507 75.7142C333.656 75.7142 349.992 58.8236 349.992 37.9907C349.992 17.1578 333.656 0.267173 313.507 0.267173V0.233154Z",
    fill: "#F57B3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorimg5);
export default __webpack_public_path__ + "static/media/Vectorimg5.e27cfd2761ad77fefe5e2eaa4f61b45f.svg";
export { ForwardRef as ReactComponent };